import { NAV } from "../../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#040404] pt-24 pb-10 overflow-hidden">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-3 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <img src="/mc-logo.png" alt="Ms Chancellor" className="h-12 w-12 object-contain" />
              <span className="font-serif text-lg text-gold">Ms Chancellor Entertainment</span>
            </div>
            <p className="mt-6 text-white/50 text-sm leading-relaxed max-w-xs">
              Ministry, entertainment, and inspiration — making a global impact for His glory.
            </p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-white/70 hover:text-gold transition-colors text-sm">{n.label}</a>
                </li>
              ))}
              <li><a href="#contact" className="text-white/70 hover:text-gold transition-colors text-sm">Book Teresa</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-5">Connect</p>
            <a href="mailto:booking@mschancellor.com" className="text-gold hover:text-gold-light transition-colors">booking@mschancellor.com</a>
            <p className="mt-5 font-serif italic text-white/60 text-lg max-w-xs">
              "If it's in your mind, it's in your future."
            </p>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">© {new Date().getFullYear()} Ms Chancellor Entertainment. All rights reserved.</p>
          <p className="text-white/30 text-xs">Founder — Teresa W. Lindsey</p>
        </div>
      </div>

      {/* Oversized wordmark */}
      <div className="mt-16 select-none pointer-events-none">
        <p className="font-serif italic text-center leading-none text-gold/10 tracking-tighter" style={{ fontSize: "clamp(3rem, 13vw, 14rem)" }}>
          Teresa W. Lindsey
        </p>
      </div>
    </footer>
  );
};
